export const FUEL_TYPE_QUERY_KEY = "fuelTypes"
export const FUEL_TYPE_LIST_QUERY_KEY = "fuelTypesList"
export const DELIVERY_ADDRESS_QUERY_KEY = "delivery-addresses"
export const DELIVERY_ADDRESS_FOR_ORDER_QUERY_KEY = "addresses/order"
export const DRIVER_QUERY_KEY = "drivers"
export const DRIVER_FOR_ORDER_QUERY_KEY = "drivers/order"
export const CUSTOMER_QUERY_KEY = "customers"
export const CUSTOMER_CONTEXT_QUERY_KEY = "customersContext"
export const CUSTOMER_SELECT_LIST_QUERY_KEY = "customers/selectList"
export const CUSTOMER_CLIENT_QUERY_KEY = "customer-clients"
export const CUSTOMER_CATEGORY_QUERY_KEY = "customer-categories"
export const CUSTOMER_CATEGORY_SELECT_LIST_QUERY_KEY = "customer-categories/selectList"
export const CUSTOMER_CATEGORY_SUM_QUERY_KEY = "customer-categories/sum"
export const CUSTOMER_CATEGORY_CARD_QUERY_KEY = "customer-categories/card"
export const CUSTOMER_TYPE_QUERY_KEY = "customer_types"
export const CUSTOMER_BALANCE_QUERY_KEY = "customer_balance"
export const TRANSPORT_QUERY_KEY = "transports"
export const TRANSPORT_FOR_ORDER_QUERY_KEY = "transports/order"
export const TRANSPORT_TYPE_QUERY_KEY = "transportTypes"
export const TRANSPORT_MODELS_QUERY_KEY = "transportModels"
export const DEPOT_QUERY_KEY = "depots"
export const DEPOT_LIST_QUERY_KEY = "depotsList"
export const FUEL_QUERY_KEY = "fuels"
export const FUEL_DASHBOARD_DEPOT_QUERY_KEY = "fuels/dashboard/depot"
export const FUEL_DASHBOARD_DATE_QUERY_KEY = "fuels/dashboard/date"
export const FUEL_QUOTES_QUERY_KEY = "fuelQuotes"
export const LAST_FUEL_QUOTES_QUERY_KEY = "fuelQuotes/lastSetValue"
export const FUEL_QUOTES_SETTINGS_QUERY_KEY = "fuelQuotesCategorySettings"
export const FUEL_LIMITS_QUERY_KEY = "fuelLimits"
export const FUEL_LIMITS_SETTINGS_QUERY_KEY = "fuelLimitsCategorySettings"
export const ORDER_QUERY_KEY = "orders"
export const ORDER_LOGS_QUERY_KEY = "orders/logs"
export const ORDER_DISPATCHER_QUERY_KEY = "dispatcherOrders"
export const ORDER_DISPATCHER_TIME_QUERY_KEY = "dispatcherOrders_timeCoordinate"
export const ORDER_DISPATCHER_TIME_COUNT_QUERY_KEY = "dispatcherOrders_timeCoordinate_count"
export const ORDER_REPORT_QUERY_KEY = "order/reports"
export const ORDER_STATUS_QUERY_KEY = "orders/statuses"
export const DELIVERY_TYPE_QUERY_KEY = "orders/delivery-types"
export const EXCHANGE_TYPE_QUERY_KEY = "orders/exchange-types"
export const PAYMENT_STATUS_QUERY_KEY = "orders/payment-statuses"
export const USER_QUERY_KEY = "users"
export const USER_SELECT_LIST_BY_ROLE_QUERY_KEY = "users/selectList"
export const USER_ADMIN_QUERY_KEY = "users/admin"
export const ROLE_QUERY_KEY = "roles"
export const ROLE_LIST_QUERY_KEY = "roles/list"
export const FINANCE_QUERY_KEY = "finance"
export const FINANCE_CUSTOMER_QUERY_KEY = "finance/customer"
export const FINANCE_DATA_RECORD_QUERY_KEY = "finance/records"
export const FINANCE_DATA_FROM_MAILBOX_RECORD_QUERY_KEY = "finance/record-mailbox"
export const COUNTRY_QUERY_KEY = "countries"
export const AUTHORITIES_QUERY_KEY = "authorities"
export const PROVIDER_QUERY_KEY = "providers"
export const TIME_COORDINATE_QUERY_KEY = "time-coordinate"
export const TIME_UNLOAD_FUEL_FREE_KEY = "timeUnloadFuel/free"
export const TIME_UNLOAD_FUEL_AVAILABLE_KEY = "timeUnloadFuel/available"
export const TIME_ALL_UNLOAD_FUEL_BY_DATE_KEY = "timeUnloadFuel/all-by-date"
export const WAYBILL_QUERY_KEY = "waybills"
export const NOTIFICATION_SETTINGS_QUERY_KEY = "notificaitonSettings"
export const NOTIFICATION_QUERY_KEY = "notificaitons"
export const NOTIFICATION_NOT_READ_QUERY_KEY = "notificaitons/not-read"
export const NOTIFICATION_NOT_READ_COUNT_QUERY_KEY = "notificaitons/not-read-count"
export const NOTIFICATION_COUNT_BY_VERIFICATION_AWAITS_QUERY_KEY = "notificaitons/count-by-verification"
export const ANALYTICS_PRICES_GET_QUERY_KEY = "pricesAnalytics/Get"
export const ANALYTICS_REFUSALS_GET_QUERY_KEY = "refusalsAnalytics/Get"
export const ANALYTICS_REFUSALS_COMPARISON_ORDER_COUNT_QUERY_KEY = "refusalsAnalytics/comparison-all-order"
export const ANALYTICS_PRICES_COMPARISON_PERIOD_QUERY_KEY = "pricesAnalytics/comparison-period"
export const ANALYTICS_ORDERS_GET_QUERY_KEY = "ordersAnalytics/Get"
export const ANALYTICS_SALES_GET_QUERY_KEY = "salesAnalytics/Get"
export const ANALYTICS_DELIVERIES_PICKUPS_GET_QUERY_KEY = "deliveriesPickupsAnalytics/Get"
export const ANALYTICS_LIMITS_GET_QUERY_KEY = "limitsAnalytics/Get"
export const ANALYTICS_LIMITS_EXEL_QUERY_KEY = "limitsAnalytics/Excel"
export const ANALYTICS_LIMITS_OPENING_SALE_QUERY_KEY = "limitsAnalytics/GetOpeningSaleDifferanceAnalytics"
export const ANALYTICS_LIMITS_OPENING_SALE_EXCEL_QUERY_KEY = "limitsAnalytics/GetOpeningSaleDifferanceAnalyticsExcel"
export const CUSTOMER_SETTING_QUERY_KEY = "customer-settings"
export const YEAR_QUERY_KEY = "years"
export const YEAR_LIST_QUERY_KEY = "yearsList"
export const QUALITY_PASSPORT_QUERY_KEY = "qualityPassport"
export const CARRIER_QUERY_KEY = "carriers"
export const CARRIER_LIST_QUERY_KEY = "carriersList"
export const NAFTA_ORGANIZATION_INFO_QUERY_KEY = "naftaOrganizationInfo"
export const FINANCE_SOAP_RECORD_CUSTOMER_STATUS_QUERY_KEY = "finance-data/status"
export const FINANCE_OPERATION_TYPE_QUERY_KEY = "finance/operation-type"
export const FINANCE_RETURN_FUNDS_QUERY_KEY = "finance/returns"
export const FINANCE_RETURN_STATUS_QUERY_KEY = "finance/return-status"

export const BULK_ORDER_QUERY_KEY = "bulkOrder"
export const REQUEST_QUOTE_QUERY_KEY = "requestQuote"
export const PERSONAL_QUOTE_QUERY_KEY = "personalOffer"
export const BULK_ORDER_LIST_QUERY_KEY = "bulkOrderList"
export const BULK_ORDER_STATUS_QUERY_KEY = "bulkOrder/statuses"
export const REQUEST_QUOTE_STATUS_QUERY_KEY = "requestQuote/statuses"
export const SHIPPING_SCHEDULE_QUERY_KEY = "shippingSchedule"
export const TIMER_QUERY_KEY = "timers"
export const TIMER_LIST_QUERY_KEY = "timersList"
/**
 * Возвращает url для получения экселя
 * @param basePath Url ресурса
 * @return Если !basePath, то "", иначе basePath + "/Excel"
 */
export const getExcelQueryKey = (basePath: string) => {
  if (!basePath)
    return ""

  return basePath + "/Excel"
}